var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.248,
    height: 16.465,
    viewBox: "0 0 16.248 16.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.209,18l-11.7,11.7-.728,4.761,4.555-.956L38.025,21.814Zm2.363,3.816L34.785,23.6l-2.363-2.363,1.787-1.787Zm-2.514,2.514-6.663,6.663-2.363-2.363L31.7,21.965Zm-8.236,8.236-2.8.589.453-2.962.835-.835,2.363,2.363Z",
    transform: "translate(-21.777 -17.998)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6beb2524193bc3524b315e1000527146.svg";
export { ForwardRef as ReactComponent };